function createProxyConstructor(type) {
  return function (context) {
    return new Proxy(new Map(), {
      get(obj, property) {
        if (!obj.has(property)) {
          const node = context.querySelector(`[data-${type}=${property}]`);
          obj.set(property, node);
        }
        return obj.get(property);
      },
      set(obj, property, value) {
        if (typeof value === 'string') {
          const node = context.querySelector(`[data-${type}=${property}]`);
          obj.set(property, node);
        } else if (value.nodeType) {
          obj.set(property, value);
        }
      },
      deleteProperty(obj, property) {
        return obj.delete(property);
      },
    });
  };
}

export const NodesProxy = createProxyConstructor('selector');
export const ActionsProxy = createProxyConstructor('action');
